const NAMESPACE = "sensitiveReport";

const KEYS = {
    reportStatement: "reportStatement",
    passwordRecommend: "passwordRecommend",
    passwordProtection: "protectionStatement",
    useWeakerEncryptionLabel: "useWeakerEncryptionLabel",
    createPasswordLabel: "createPasswordLabel",
    confirmPasswordLabel: "confirmPasswordLabel",
    passwordMismatchMessage: "passwordMismatchMessage"
};

const MESSAGES = {
    [KEYS.reportStatement]: {
        value: "This report contains sensitive data. Please create a password that will be required to open the report. We strongly recommend that you use a password that is ",
        comment: ""
    },
    [KEYS.passwordRecommend]: {
        value: " not your PowerClerk password.",
        comment: "Enable"
    },
    [KEYS.passwordProtection]: {
        value: "Note: The report is a password-protected and encrypted (AES-256) zip file, which may require additional file decryption software to open."
    },
    [KEYS.useWeakerEncryptionLabel]: {
        value: "Use weaker encryption to open with basic software?"
    },
    [KEYS.createPasswordLabel]: {
        value: "Create Password: "
    },
    [KEYS.confirmPasswordLabel]: {
        value: "Confirm Password: "
    },
    [KEYS.passwordMismatchMessage]: {
        value: "Password and confirm password must match."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
